import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import { ProgressBar, H4, FormGroup, NumericInput, Button, Checkbox } from '@blueprintjs/core';
import MaterialTable from 'material-table';
import { TablePagination } from '@material-ui/core';
import { prepDangerouslySetInnerHTMLString } from '../concord/utils';

class ClusterContexts extends React.PureComponent {

  state = {
   cutThreshold : 0.2,
   sampleSize : 1000,
   onlySyntax : false,
   waitingForCluster:false,
   permalink:null,
  }

  // first arg is the rowData
  openContextWindow = (e) => {
    e.preventDefault();
    
    if (! e.currentTarget.value) { // use e.currentTarget instead of e.target
        return;
    }
    const concordData=this.state.sentId2Concord[e.currentTarget.value];
    if (! concordData) {
        // console.log("concordData vide");
        return;
    }  
    const { results } = this.props;
    
    const docMeta=results.concord.docMeta;
    const lang=results.lang;
    const aligned_language=results.aligned_language;

    const data = {
      sent_id: concordData.sentId,
      collection: docMeta[concordData.docId].collection,
      lang: lang,
      aligned_language:aligned_language
    };

    const endpoint = '/get_result_meta.ajax.php';
    fetch(
      process.env.REACT_APP_API_BASE + endpoint, {
        credentials: process.env.REACT_APP_CREDENTIALS,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
      })
      .then((res) => {
        if (res.status !== 200) {
          console.log(`Issue reaching ${endpoint}`);
          return;
        }
        res.json().then((concordDetail) => {
          window.open(concordDetail.permalink,'_blank')
        })
      })
      .catch(() => {
        console.log(`Network error when trying to fetch ${endpoint}`);
      })
     
  };

  runContextClustering = () => {

    // the first time, the hash sentId2Concord must be build
    if (! this.state.sentId2Concord) {
        const sentId2Concord={};
        for (const subCorpus of Object.keys(this.props.results.concord)) {
            for (var i in this.props.results.concord[subCorpus]) {
                const concord=this.props.results.concord[subCorpus][i];
                sentId2Concord[concord.sentId]=concord;
            }
        }
        this.setState({sentId2Concord:sentId2Concord});
    }

    const endpoint = '/clusterContexts.ajax.php';
    const data={
        session_id:     this.props.results['session_name'],
        cut_threshold:  this.state.cutThreshold,
        sample_size:    this.state.sampleSize,
        only_syntax:    this.state.onlySyntax
    }

    this.setState({ waitingForCluster: true});
    fetch(
      process.env.REACT_APP_API_BASE + endpoint, {
        credentials: process.env.REACT_APP_CREDENTIALS,
        headers: { 'Content-Type': 'application/json' },
        method: 'POST',
        body: JSON.stringify(data),
      }
    )
    .then((res) => {
      if (res.status !== 200) {
        console.log(`Issue reaching ${endpoint}`);
        return;
      }
      res.json().then((data) => {
        //console.log("data"+data);
        this.setState({ waitingForCluster: false, clusters: data });
      });
    })
  };
  render() {
      const { t } = this.props;
      const span=60;
      const formGroupStyle = {
        display: 'flex',
        //justifyContent: 'space-between',
      };
      let table;
      if (this.state.clusters) {
        const tableData=[];
        for (var i in this.state.clusters) {
            for (const sentId of this.state.clusters[i]) {
                
                const concord=this.state.sentId2Concord[sentId];
                if (concord) {
                    concord.clustId=i;
                    tableData.push(concord);
                } else {
                    console.log("Non trouvé SentId="+sentId)
                }
            }
        }  
        table=<MaterialTable
            title={t('conc')}
            
            columns={[
                {   
                    title: t('ID'), 
                    field: 'clustId', 
                    width: '5%',
                    cellStyle: {
                        textAlign:'center',
                        padding:'0',
                    },
                    headerStyle:{
                        textAlign:'center',
                        padding:'0'
                    }
                }, 
                {   
                    title: t('context'), 
                    width: '5%',
                    render: rowData => <Button onClick={this.openContextWindow} value={rowData.sentId} icon='info-sign'></Button>,
                    cellStyle: {
                        textAlign:'center',
                        padding:'0',
                    },
                    headerStyle:{
                        textAlign:'center',
                        padding:'0'
                    }
                },
                {   
                  title: t('idSent'), 
                  width: '15%',
                  field: 'sentId',
                  cellStyle: {
                      textAlign:'center',
                      padding:'0',
                  },
                  headerStyle:{
                      textAlign:'center',
                      padding:'0'
                  }
                },
                {   
                    title: t('leftContext'), 
                    field: 'left',
                    width: '35%',
                    render: rowData => <div dangerouslySetInnerHTML={prepDangerouslySetInnerHTMLString(rowData.left.slice(-span))} /> ,
                    cellStyle: {
                        textAlign:'right',
                        padding:'0',                    
                    },
                    headerStyle:{
                        textAlign:'center'
                    }
                },
                
                {   
                    title: t('node'), 
                    field: 'node', 
                    render: rowData => <div dangerouslySetInnerHTML={prepDangerouslySetInnerHTMLString(rowData.node)} /> ,
                    cellStyle:{
                        textAlign:'center',
                        padding:'0',                          
                    }, 
                    headerStyle:{
                        textAlign:'center'
                    }
                },
        
                {   
                    title: t('rightContext'), 
                    field: 'right', 
                    width: '35%',
                    render: rowData => <div dangerouslySetInnerHTML={prepDangerouslySetInnerHTMLString(rowData.right.substr(0,span))} /> ,
                    cellStyle : {
                        textAlign:'left',
                        padding:'0',
                    },
                    headerStyle:{
                        textAlign:'center'
                    }
                },
            ]}

            data={ tableData }
            //onRowClick={((evt, selectedRow) => setSelectedRow(selectedRow.tableData.id))}
            components={{
                 Pagination: props => (
                   <TablePagination
                     {...props}
                     rowsPerPageOptions={[10, 25, 50, 100, tableData.length ]}
                   />
                 ),
             }}

            options={{
                selection:true,
                filtering:true,
                search: true,
                sorting: true,
                exportButton: true,
                exportFileName: 'clusters',
                padding: 'dense',
                pageSize:100,
                tableLayout: 'fixed',
                //exportAlldata: true,
                rowStyle: (rowData) => ({
                    backgroundColor: ( rowData.clustId % 2 === 0) ? '#EEE' : '#FFF',
                    height:'40px',
                    maxHeight:'40px'
                })
            }}
        />;
      }
    
      return (
        <>
          <div className="margin-top-2-rem">
                <H4>{t('clust')}</H4>
                <p>{t('clustExplanation')}</p>
                <FormGroup
                    helperText={t('sampleSizeHelp')}
                    label={t('sampleSize')}
                    inline={true}
                    style={formGroupStyle}
                    >
                    <NumericInput
                        min={10} buttonPosition={null}
                        value={this.state.sampleSize}
                        onValueChange={(newValue) => this.setState({ sampleSize : newValue})}
                    />
                </FormGroup>
                <FormGroup
                    helperText={t('cutThresholdHelp')}
                    label={t('cutThreshold')}
                    inline={true}
                    style={formGroupStyle}
                    >
                    <NumericInput
                        min={0}
                        max={1}
                        buttonPosition={null}
                        value={this.state.cutThreshold}
                        onValueChange={(newValue) => this.setState({ cutThreshold : newValue})}
                    />
                    <Checkbox
                        disabled={false}
                        label={t('onlySyntax')}
                        checked={this.state.onlySyntax}  // to control the component
                        value={true}
                        onChange={()=>{ this.setState({onlySyntax:! this.state.onlySyntax}) }}
                    />
                </FormGroup>
                <FormGroup>
                    <Button onClick={this.runContextClustering}>{t('runContextClustering')}</Button>
                </FormGroup>

                { this.state.waitingForCluster && <ProgressBar/> }

                { table && 
                    <p>{t('clickThreeTimesToOpenPopup')}</p>
                }
                {table}

          </div>
        </>
      );
  }
}

ClusterContexts.propTypes = {
  results: PropTypes.object,
};

export default withTranslation()(ClusterContexts);
